<template>
  <div class="process-control">
    <div
        v-if="htmlContent"
        @click="statusExpandType = false"
        v-html="handleProcessBase64Default"
        class="html-content"
    ></div>
    <div
        v-else
        v-html="handleProcessBase64"
        @click="statusExpandType = false"
        class="html-content"
    ></div>
    <div @click.stop="dropDown()" class="drop-down">
      <div class="ml10 ell">
        <el-button type="info">
          流程控制
          <span
              :class="[
              'iconfont-lunan icon-lunan-xiaosanjiaodown',
              statusExpandType ? 'icon-transform' : '',
              'select-arrow',
            ]"
          ></span>
        </el-button>
      </div>
    </div>

    <div class="type-select" v-if="statusExpandType">
      <div class="search">
        <el-input
            clearable
            v-model="processNames"
            placeholder="请输入流程名称"
            style="width: 90%"
        >
        </el-input>
        <span> | </span>
        <img
            style="cursor: pointer"
            @click="getProcessByName"
            src="@src/common/assets/images/search.png"
            alt=""
        />
      </div>
      <el-scrollbar style="height: calc(100% - 50px)">
        <div class="content-area" v-if="handleProcessList.length">
          <div
              v-for="item in handleProcessList"
              :key="item.handleProcessCode"
              class="processList flex-row"
          >
            <!-- <div style="display: flex"> -->
            <span
                class="processList-title ell mr10"
                :title="item.handleProcessName"
            >{{ item.handleProcessName }}</span
            >

            <div class="process-btn" style="float: right">
              <el-button
                  size="small"
                  @click="handleProcess(item, 'handleProcessBase64')"
                  type="info"
                  class="process-btn1"
              >现场处置说明
              </el-button
              >
              <el-button
                  size="small"
                  @click="handleProcess(item, 'simpleProcessBase64')"
                  type="info"
                  class="process-btn2"
              >简化流程说明
              </el-button
              >
            </div>
            <!-- </div> -->
          </div>
        </div>
        <div v-else style="margin-top: 15%; text-align: center">暂无数据</div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import {api} from "../api";

export default {
  name: "process-control",
  props: ["stepType", "handleAlarmType"],
  data() {
    return {
      htmlContent: true,
      handleProcessSimpleShow: false,
      handleProcessShow: false,
      handleProcessList: [],
      statusExpandType: false,
      typeExpandType: false,
      searchFormShow: false,
      handleProcessFile: "",
      simpleProcessFile: "",
      // 处置流程
      handleProcessBase64: "",
      // 简化流程
      simpleProcessBase64: "",
      processNames: "",
      processName: [],
      handleProcessCode: "",
      handleProcessBase64Default: "",
    };
  },
  created() {
    this.getDefaultProcess();
  },
  methods: {
    //默认显示处理流程
    getDefaultProcess() {
      const params = {
        handleProcessName: this.processNames,
        simpleProcessFile: "",
        handleProcessType: this.handleAlarmType,
        pageNum: 1,
        pageSize: 999,
        subHandleProcessType: "",
        handleProcessFile: "",
      };
      this.$fetch(api.reserve.queryEmergencyHandleProcessList, params).then(
          (res) => {
            if (res.success) {
              const handleProcessList = res.returnObj.list;
              // 默认显示第一个
              this.processNames = handleProcessList.handleProcessName;
              this.handleProcessCode = res.returnObj.list[0].handleProcessCode;
              this.handleProcessBase64 =
                  res.returnObj.list[0].handleProcessBase64;
              this.handleProcessList = handleProcessList;
              const param = {handleProcessCode: this.handleProcessCode};
              this.$fetch(
                  api.reserve.queryEmergencyHandleProcessDetail,
                  param
              ).then((res) => {
                if (res.success) {
                  this.handleProcessBase64Default = this.decodeBase64(
                      res.returnObj.handleProcessBase64
                  );
                }
              });
              // });
            }
          }
      );
    },
    //查询应急处理流程列表接口
    queryEmergencyHandleProcessList() {
      const params = {
        handleProcessName: this.processNames,
        simpleProcessFile: "",
        handleProcessType: this.handleAlarmType,
        pageNum: 1,
        pageSize: 1000,
        subHandleProcessType: "",
        handleProcessFile: "",
      };
      this.$fetch(api.reserve.queryEmergencyHandleProcessList, params).then(
          (res) => {
            if (res.success) {
              const handleProcessList = res.returnObj.list || [];

              // this.handleProcessCode = res.returnObj.list[0].handleProcessCode;
              // this.processNames = handleProcessList.handleProcessName;
              this.handleProcessList = handleProcessList;
              // handleProcessList.forEach((item, index) => {
              //   this.handleProcessBase64 = item.handleProcessBase64;
              // });
            } else {
              this.$message.error("获取流程列表失败!");
            }
          }
      );
    },
    //查询应急处理流程列表
    getProcessByName() {
      this.queryEmergencyHandleProcessList();
    },
    //流程控制下拉选择
    dropDown() {
      this.statusExpandType = !this.statusExpandType;
      this.typeExpandType = this.searchFormShow = false;
      this.getProcessByName();
    },
    //获取流程说明--查询处理详情
    handleProcess(item, key) {
      // console.log(key, "---key---");
      const param = {handleProcessCode: item.handleProcessCode};
      this.$fetch(api.reserve.queryEmergencyHandleProcessDetail, param).then(
          (res) => {
            // console.log(res);
            if (res.success) {
              this.htmlContent = false;
              // console.log("enter");
              this.handleProcessBase64 = this.decodeBase64(res.returnObj[key]);
              // console.log(this.handleProcessBase64);
            }
          }
      );
    },

    //文件转码
    decodeBase64(base64) {
      // 对base64转编码
      const decode = atob(base64);
      const str = decodeURI(decode);
      return str;
    },
  },
};
</script>
<style scoped lang="scss">
@import "~@src/common/assets/style/mixin";

.process-control {
  width: 100%;
  height: 100%;
  position: relative;

  .html-content {
    height: 80%;
    position: absolute;
    top: 16px;
    width: 100%;
    font-size: 16px;
    float: left;
    padding: 26px;
    line-height: 1.5;
    background-color: rgba(255, 255, 255, .5);
  }

  .drop-down {
    position: absolute;
    right: 0px;
    top: -35px;

    .process-span {
      color: #9aa6c1;
      line-height: 36px;
      font-size: 20px;
      font-weight: bolder;
      z-index: 33;
    }

    .select-arrow,
    .icon-transform {
      margin-left: 5px;
      // font-size: 18px;
      color: #9aa6c1;
    }

    .select-arrow {
      display: inline-block;
      transition: 0.3s;
      -moz-transition: 0.3s;
      /* Firefox 4 */
      -webkit-transition: 0.3s;
      /* Safari 和 Chrome */
      -o-transition: 0.3s;
      cursor: pointer;
    }

    .icon-transform {
      transform: rotate(180deg);
    }
  }

  .type-select {
    // @include set_theme_color(background-color, blur-color);
    background: rgba(#ffffff, 0.6);
    backdrop-filter: blur(15px);
    position: absolute;
    top: 10px;
    right: 0px;
    width: 450px;
    height: 250px;
    // overflow: hidden;
    border-radius: 5px;
    // padding: 10px;
    @include set_animation(all);
    z-index: 2;

    .search {
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .content-area {
      padding: 0px 0 10px;
      // height: 200px;
      .processList {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
          @include set_theme_color(background-color, blur-color);
        }

        .processList-title {
          display: inline-block;
          width: 45%;
          // cursor: pointer;
          // line-height: 35px;
        }
      }
    }
  }
}
</style>
